import { Action } from '@ngrx/store';
import { Utente } from 'src/app/shared/models/utente.model';
import { RoleType } from 'src/app/shared/models/role-type.model';
import { ResourceType } from 'src/app/shared/models/resource-type.model';
import { GlossaryType } from 'src/app/shared/models/glossary-type.model';
import { Resource } from 'src/app/shared/models/resource.model';
import { NoteType } from 'src/app/shared/models/note-type.model';
import { AttachmentType } from 'src/app/shared/models/attachment-type.model';




/**Descrizione del tipo LOGIN */
export const LOGIN = '[AUTH] Login';
/**Descrizione del tipo LOGIN_SUCCESS */
export const LOGIN_SUCCESS = '[AUTH] Login success';
/**Descrizione del tipo LOGIN_FAILURE */
export const LOGIN_FAILURE = '[AUTH] Login failure';
/**Descrizione del tipo AUTO_LOGIN */
export const AUTO_LOGIN = '[AUTH] Auto login';
/**Descrizione del tipo LOGOUT */
export const LOGOUT = '[AUTH] Logout';
/**Descrizione del tipo SHOW_WARNING */
export const SHOW_WARNING = '[AUTH] Mostra warning di logout';
/**Descrizione del tipo START_KEEPALIVE */
export const START_KEEPALIVE = '[AUTH] Inizio chiamata keepalive';
/**Descrizione del tipo KEEPALIVE_SUCCESS */
export const KEEPALIVE_SUCCESS = '[AUTH] Azione di keepalive avvenuta con successo';
/**Descrizione del tipo START_UPDATE_LOGGEDUSER */
export const START_UPDATE_LOGGEDUSER = '[AUTH] Inizio aggiornamento loggedUser';
/**Descrizione del tipo UPDATE_LOGGEDUSER_SUCCESS*/
export const UPDATE_LOGGEDUSER_SUCCESS = '[AUTH] Aggiornamento loggedUser avvenuto con successo';
/**Descrizione del tipo UPDATE_LOGGEDUSER_FAILURE*/
export const UPDATE_LOGGEDUSER_FAILURE = '[AUTH] Fallito aggiornamento loggedUser';
/**Descrizione del tipo KEEPALIVE_FAILURE */
export const KEEPALIVE_FAILURE = '[AUTH] Azione di keepalive fallita';

/**Descrizione per il tipo StartGetRoles */
export const START_GET_ROLES = '[AUTH] Inizio recupero elenco tipologie di ruolo';
/**Descrizione per il tipo GetRolesSuccess */
export const GET_ROLES_SUCCESS = '[AUTH] Recupero tipologie di ruolo avvenuto con successo';
/**Descrizione per il tipo GetRolesFailure */
export const GET_ROLES_FAILURE = '[AUTH] Mancato recupero tipologie di ruolo';

/**Descrizione per il tipo StartGetResType */
export const START_GET_RES_TYPE = '[AUTH] Inizio recupero elenco tipologie di risorse';
/**Descrizione per il tipo GetResTypeSuccess */
export const GET_RES_TYPE_SUCCESS = '[AUTH] Recupero tipologie di risorse avvenuto con successo';
/**Descrizione per il tipo GetResTypeFailure */
export const GET_RES_TYPE_FAILURE = '[AUTH] Mancato recupero tipologie di risorse';

/**Descrizione per il tipo LoadingPage */
export const LOADING_PAGE = '[AUTH] Caricamento di una pagina';

/**Descrizione per il tipo StartGetGlosType */
export const START_GET_GLOS_TYPE = '[AUTH] Inizio recupero elenco tipologie di glossari';
/**Descrizione per il tipo GetGlosTypeSuccess */
export const GET_GLOS_TYPE_SUCCESS = '[AUTH] Recupero tipologie di glossari avvenuto con successo';
/**Descrizione per il tipo GetGlosTypeFailure */
export const GET_GLOS_TYPE_FAILURE = '[AUTH] Mancato recupero tipologie di glossari';

/**Descrizione per il tipo StartGetNoteType */
export const START_GET_NOTE_TYPE = '[AUTH] Inizio recupero elenco tipologie di note';
/**Descrizione per il tipo GetNoteTypeSuccess */
export const GET_NOTE_TYPE_SUCCESS = '[AUTH] Recupero elenco tipologie di note avvenuto con successo';
/**Descrizione per il tipo GetNoteTypeFailure */
export const GET_NOTE_TYPE_FAILURE = '[AUTH] Mancato recupero tipologie di note';

/**Descrizione per il tipo StartGetAssignedResources */
export const START_GET_ASSIGNED_RESOURCES = '[AUTH] Inizio recupero risorse assegnate utente loggato';
/**Descrizione per il tipo GetAssignedResourcesSuccess */
export const GET_ASSIGNED_RESOURCES_SUCCESS = '[AUTH] Recupero risorse assegnaye a utente loggato avvenuto con successo';
/**Descrizione per il tipo GetAssignedResourcesFailure */
export const GET_ASSIGNED_RESOURCES_FAILURE = '[AUTH] Mancato recupero delle risorse assegnate a utente loggato';

/**Descrizione per il tipo StartGetTemporary */
export const START_GET_TEMPORARY = '[AUTH] Inizio recupero note personali utente loggato';
/**Descrizione per il tipo GetTemporarySuccess */
export const GET_TEMPORARY_SUCCES = '[AUTH] Recupero note personali avvenuto con successo';
/**Descrizione per il tipo GetTemporaryFailure */
export const GET_TEMPORARY_FAILURE = '[AUTH] Mancato recupero note personali';

/**Descrizione per il tipo StartPostTemporary */
export const START_POST_TEMPORARY = '[AUTH] Inizio modifica note personali utente loggato';
/**Descrizione per il tipo PostTemporarySuccess */
export const POST_TEMPORARY_SUCCES = '[AUTH] Modifica note personali avvenuto con successo';
/**Descrizione per il tipo PostTemporaryFailure */
export const POST_TEMPORARY_FAILURE = '[AUTH] Mancata modifica note personali';

/**Descrizione per il tipo StartGetAttachmentTypes */
export const START_GET_ATTACHMENT_TYPES = '[AUTH] Inizio recupero elenco tipologie di allegati';
/**Descrizione per il tipo GetAttachmentTypesSuccess */
export const GET_ATTACHMENT_TYPES_SUCCESS = '[AUTH] Recupero elenco tipologie di allegati avvenuto con successo';
/**Descrizione per il tipo GetAttachmentTypesFailure */
export const GET_ATTACHMENT_TYPES_FAILURE = '[AUTH] Mancato recupero elenco tipologie di allegati';

/**Azione di Login */
export class Login implements Action {
    readonly type = LOGIN;

    /**
     * Il costruttore dell'azione prende in ingresso i dati inseriti dall'utente per l'accesso
     * @param payload {Object} username {string} e password {string}
     */
    constructor(public payload: {username: string; password: string}) {
        console.log('ACTION: ' + LOGIN);
    }
}

/**Azione di auto-login, attivata dall'AppComponent quando la pagina viene ricaricata*/
export class AutoLogin implements Action {
    readonly type = AUTO_LOGIN;
}

/**Azione di LoginSuccess */
export class LoginSuccess implements Action {
    readonly type = LOGIN_SUCCESS;
    
    /**
     * Costruttore per l'azione di login avvenuto con successo
     * @param payload {Utente} utente loggato
     */
    constructor(public payload: Utente) {
        console.log('ACTION: ' + LOGIN_SUCCESS);
    }
}

/**Azione di LoginFailure */
export class LoginFailure implements Action {
    readonly type = LOGIN_FAILURE;

    /**
     * Costruttore per l'azione di fallito login
     * @param payload {string} messaggio di errore per mancato login
     */
    constructor(public payload: any) {
        console.log('ACTION: ' + LOGIN_FAILURE);
    }
}

/**Azione di Logout */
export class Logout implements Action {
    readonly type = LOGOUT;
}

/**Azione di ShowWarning */
export class ShowWarning implements Action {
    readonly type = SHOW_WARNING;
    
    /**
     * Costruttore dell'azione ShowWarning
     * @param payload {boolean} indica se debba essere mostrato o meno l'avviso di scadenza key
     */
    constructor(public payload: boolean) {}
}

/**Azione di StartKeepalive */
export class StartKeepalive implements Action {
    readonly type = START_KEEPALIVE;
}

/**Azione di KeepaliveSuccess */
export class KeepaliveSuccess implements Action {
    readonly type = KEEPALIVE_SUCCESS;
}

/**
 * Costruttore per l'azione di modifica dell'utente loggato
 * @param payload {object} utente prima della modifica, vecchiaPW: password originale, nuovaPw: password modificata
 */

export class StartUpdateLoggedUser implements Action {
    readonly type = START_UPDATE_LOGGEDUSER;

    constructor(public payload: {user:number, nomeCampo: string, newValue: any}[] ) {}
}

/** Azione di avvenuta modifica dell'utente loggato'*/
export class UpdateLoggedUserSuccess implements Action {
    readonly type = UPDATE_LOGGEDUSER_SUCCESS;
/**
 * 
 * @param payload {Utente} loggedUser aggiornato
 */
    constructor(public payload: Utente) {}
}

/**Azione di mancata modifica dell'utente loggato*/
export class UpdateLoggedUserFailure implements Action {
    readonly type = UPDATE_LOGGEDUSER_FAILURE;

    constructor(public payload: any) {}
}

/**Azione di KeepaliveFailure */
export class KeepaliveFailure implements Action {
    readonly type = KEEPALIVE_FAILURE;
}

/**Azione di inizio recupero tipologie di ruolo disponibili */
export class StartGetRoles implements Action {
    readonly type = START_GET_ROLES;
}

/**Azione di avvenuto recupero elenco tipologie di ruolo */
export class GetRolesSuccess implements Action {
    readonly type = GET_ROLES_SUCCESS;

    /**
     * Costruttore per l'azione di avvenuto recupero ruoli
     * @param payload {RoleType[]} elenco delle tipologie di ruolo
     */
    constructor(public payload: RoleType[]) {}
}

/**Azione di mancato recupero elenco tipologie di ruolo */
export class GetRolesFailure implements Action {
    readonly type = GET_ROLES_FAILURE;

    constructor(public payload: any) {}
}

/**Azione di inizio recupero tipologie di risorse */
export class StartGetResType implements Action {
    readonly type = START_GET_RES_TYPE;
}

/**Azione di avvenuto recupero elenco tipologie di risorsa */
export class GetResTypeSuccess implements Action {
    readonly type = GET_RES_TYPE_SUCCESS;

    /**
     * Costruttore per GetResTypeSuccess
     * @param payload {ResourceType[]} elenco delle tipoligie di risorsa
     */
    constructor(public payload: ResourceType[]) {}
}

/**Azione di mancato recupero elenco tipologie di risorsa */
export class GetResTypeFailure implements Action {
    readonly type = GET_RES_TYPE_FAILURE;
    
    constructor(public payload: any) {}
}

/**Azione di visualizzazione del caricamento pagina */
export class LoadingPage implements Action {
    readonly type = LOADING_PAGE;

    /**
     * Costruttore per l'azione LoadingPage
     * @param payload {boolean} definisce se è in corso il caricamento o meno
     */
    constructor(public payload: boolean) {}
}

/**Azione di inizio recupero dei tipi di glossario disponibili */
export class StartGetGlosType implements Action {
    readonly type = START_GET_GLOS_TYPE;
}
/**Azione di avvenuto recupero dei tipi di glossario disponibili */
export class GetGlosTypeSuccess implements Action {
    readonly type = GET_GLOS_TYPE_SUCCESS;

    /**
     * Costruttore per l'azione GetGlosTypeAction
     * @param payload {GlossaryType[]} elenco dei tipi di glossario disponibili
     */
    constructor(public payload: GlossaryType[]) {}
}
/**Azione di mancato recupero dei tipi di glossario disponibili */
export class GetGlosTypeFailure implements Action {
    readonly type = GET_GLOS_TYPE_FAILURE;
    constructor(public payload: any) {}
}

/**Azione di inizio recupero delle risorse assegnate a un utente */
export class StartGetAssignedResources implements Action {
    readonly type = START_GET_ASSIGNED_RESOURCES;
    /**
     * Costruttore per l'azione StartGetAssignedResources
     * @param payload {number} identificativo dell'utente
     */
    constructor(public payload: number) {}
}
/**Azione di avvenuto recupero delle risorse assegnate a un utente */
export class GetAssignedResourcesSuccess implements Action {
    readonly type = GET_ASSIGNED_RESOURCES_SUCCESS;
    /**
     * Costruttore per l'azione GetAssignedResoucesSuccess
     * @param payload {Resource[]} elenco delle risorse assegnate
     */
    constructor(public payload: Resource[]) {}
}
/**Azione di mancato recupero delle risorse assegnate a un utente */
export class GetAssignedResourcesFailure implements Action {
    readonly type = GET_ASSIGNED_RESOURCES_FAILURE;
}

/**Azione di inizio recupero delle note personali */
export class StartGetTemporary implements Action {
    readonly type = START_GET_TEMPORARY;
    /**
     * Costruttore per l'azione StartGetTemporary
     * @param payload {number} identificativo dell'utente
     */
    constructor(public payload: number) {}
}
/**Azione di avvenuto recupero delle note personali */
export class GetTemporarySuccess implements Action {
    readonly type = GET_TEMPORARY_SUCCES;
    /**
     * Costruttore per l'azione GetTemporarySuccess
     * @param payload {any} le note personali recuperate
     */
    constructor(public payload: any) {}
}
/**Azione di mancato recupero delle note personali */
export class GetTemporaryFailure implements Action {
    readonly type = GET_TEMPORARY_FAILURE;
}

/**Azione di inizio aggiornamento delle note personali */
export class StartPostTemporary implements Action {
    readonly type = START_POST_TEMPORARY;
    /**
     * Costruttore per l'azione StartPostTemporary
     * @param payload {object} idUtente (number) identificativo dell'utente, newNote (string) nuovo contenuto delle note personali
     */
    constructor(public payload: {idUtente: number, newNote: string}) {}
}
/**Azione di avvenuto aggiornamento delle note personali */
export class PostTemporarySuccess implements Action {
    readonly type = POST_TEMPORARY_SUCCES;
    /**
     * Costruttore per l'azione PostTemporarySuccess
     * @param payload {any} note personali aggiornate
     */
    constructor(public payload: any) {}
}
/**Azione di mancato aggiornamento delle note personali */
export class PostTemporaryFailure implements Action {
    readonly type = POST_TEMPORARY_FAILURE;
}

/**Azione di inizio recupero dei tipi di note disponibili */
export class StartGetNoteType implements Action {
    readonly type = START_GET_NOTE_TYPE;
}
/**Azione di avvenuto recupero dei tipi di note disponibili */
export class GetNoteTypeSuccess implements Action {
    readonly type = GET_NOTE_TYPE_SUCCESS;
    /**
     * Costruttore per l'azione GetNoteTypeSuccess
     * @param payload {NoteType[]} elenco dei tipi di note
     */
    constructor(public payload: NoteType[]) {}
}
/**Azione di mancato recuper dei tipi di note disponibili */
export class GetNoteTypeFailure implements Action {
    readonly type = GET_NOTE_TYPE_FAILURE;
}

/**Azione di inizio recupero elenco tipologie di allegato */
export class StartGetAttachmentTypes implements Action {
    readonly type = START_GET_ATTACHMENT_TYPES;
}
/**Azione di avvenuto recupero elenco tipologie di allegato */
export class GetAttachmentTypesSuccess implements Action {
    readonly type = GET_ATTACHMENT_TYPES_SUCCESS;

    /**
     * Costruttore per l'azione GetAttachmentTypesSuccess
     * @param payload {AttachmentType[]} elenco delle tipologie di allegato
     */
    constructor(public payload: AttachmentType[]) {}
}
/**Azione di mancato recupero elenco tipologie di allegato */
export class GetAttachmentTypesFailure implements Action {
    readonly type = GET_ATTACHMENT_TYPES_FAILURE;
}

/**Tipo contenente le azioni di autenticazione */
export type AuthAction = 
| Login
| AutoLogin
| LoginSuccess
| LoginFailure
| Logout
| ShowWarning
| StartKeepalive
| KeepaliveSuccess
| StartUpdateLoggedUser
| UpdateLoggedUserSuccess
| UpdateLoggedUserFailure
| KeepaliveFailure
| StartGetRoles
| GetRolesSuccess
| GetRolesFailure
| StartGetResType
| GetResTypeSuccess
| GetResTypeFailure
| LoadingPage
| StartGetGlosType
| GetGlosTypeFailure
| GetGlosTypeSuccess
| StartGetAssignedResources
| GetAssignedResourcesSuccess
| GetAssignedResourcesFailure
| StartGetTemporary
| GetTemporarySuccess
| GetTemporaryFailure
| StartPostTemporary
| PostTemporaryFailure
| PostTemporarySuccess
| StartGetNoteType
| GetNoteTypeSuccess
| GetNoteTypeFailure
| StartGetAttachmentTypes
| GetAttachmentTypesSuccess
| GetAttachmentTypesFailure;
